import React from 'react'
import './index.scss'

const getRandomPercentage = () => Math.floor(Math.random() * 99 + 1)

const Divider = ({ height = '8px' }) =>
  <div className='Divider' style={{height, backgroundPosition: `${getRandomPercentage()}%, 50%`}} />

export default Divider
